module.exports = __webpack_public_path__ + "static/logo-8506bfeaf7a420cceceb1ff5b68312ba.png";